import { Checkbox } from "@chakra-ui/react"
import { EDITOR_MODE, useBlocksConfig } from "@pathwright/blocks-engine"
import { BlockText, QuillEditor } from "@pathwright/blocks/src/shared"
import IconButton from "@pathwright/ui/src/components/button/IconButton"
import LegacyCheckbox from "@pathwright/ui/src/components/form/form-checkbox/Checkbox"
import { TOOLBAR_CONFIG_TYPES } from "@pathwright/ui/src/components/quill/toolbar/QuillToolbar"
import { useUIThemeContext } from "@pathwright/ui/src/components/ui/PathwrightUI"
import filter from "lodash/filter"
import PropTypes from "prop-types"
import styled from "styled-components"
import { TaskItemWrap } from "./ui"
import { toggleComplete } from "./utils"

const StyledCheckbox = styled(LegacyCheckbox)`
  input[type="checkbox"] {
    // this is ok because the checkbox is disabled and is decorative
    appearance: none;
  }

  input[disabled] + .checkbox_label {
    cursor: not-allowed;
  }

  .checkbox_label {
    border-color: ${(p) => (p.checked ? p.checkedColor : "#999")};
    background-color: ${(p) => (p.checked ? "transparent" : "whitesmoke")};
    color: ${(p) => p.checkedColor};
  }
`

const TasklistItem = (props) => {
  const {
    // Tasklist block props
    data,
    onChange,
    mode,
    blockStyles,

    // List props
    item,
    isAtMin,
    DragHandle,
    onRemove,
    onUpdate
  } = props

  const { disableInput, templateVariables } = useBlocksConfig()
  const { primaryBrandColor } = useUIThemeContext()

  const handleChangeContent = (nextContent) => {
    onUpdate({
      attribute: "content",
      value: nextContent
    })
  }

  const handleToggleComplete = ({ checked } = {}) => {
    if (mode === EDITOR_MODE.EDIT) return

    const completedTasks = toggleComplete(item, data)
    onChange({ completedTasks }, true)
  }

  const itemCompletion =
    !!data.completedTasks &&
    filter(data.completedTasks, { order: item.order }).length

  const showControls = !isAtMin && item.content !== ""

  return (
    <TaskItemWrap blockStyles={blockStyles}>
      {mode === EDITOR_MODE.EDIT ? (
        <StyledCheckbox disabled style={{ width: "100%" }}>
          <QuillEditor
            key={`task-${item.order}`}
            toolbar={TOOLBAR_CONFIG_TYPES.SIMPLE}
            placeholder={"Add a task"}
            html={item.content}
            onChange={handleChangeContent}
            onDelete={item.content !== "" ? onRemove : null}
            className={item.content === "" ? "task-item-editor--new" : ""}
          />
        </StyledCheckbox>
      ) : (
        <Checkbox.Root
          checked={itemCompletion}
          disabled={disableInput}
          onCheckedChange={handleToggleComplete}
          w="100%"
          size="md"
          py="7px"
          // borderRadius="3px"
          colorPalette="white"
          css={{
            "& .chakra-checkbox__control": {
              borderRadius: "4px",
              border: "1px solid #999",
              borderColor: null,
              backgroundColor: "whitesmoke",
              width: "19px",
              height: "19px"
            },
            "& .chakra-checkbox__control[data-checked], & .chakra-checkbox__control[data-checked][data-disabled]":
              {
                borderColor: primaryBrandColor,
                backgroundColor: "white"
              },
            "& .chakra-checkbox__control svg": {
              strokeWidth: "1 !important"
            },
            "& .chakra-checkbox__label[data-disabled]": {
              opacity: 1
            }
          }}
        >
          <Checkbox.HiddenInput />
          <Checkbox.Control color="brand.600">
            <Checkbox.Indicator />
          </Checkbox.Control>
          <Checkbox.Label opacity={itemCompletion ? 0.7 : 1}>
            <BlockText
              html={item.content}
              templateContext={templateVariables}
            />
          </Checkbox.Label>
        </Checkbox.Root>
      )}
      {mode === EDITOR_MODE.EDIT && showControls && (
        <DragHandle>
          {() => (
            <span>
              <IconButton
                icon="arrow-double-vertical-2"
                style={{ opacity: "0.7" }}
                className="EditButton"
              />
            </span>
          )}
        </DragHandle>
      )}
      {mode === EDITOR_MODE.EDIT && showControls && (
        <IconButton icon="trash" onClick={onRemove} className="EditButton" />
      )}
    </TaskItemWrap>
  )
}

TasklistItem.propTypes = {
  data: PropTypes.object.isRequired,
  min: PropTypes.number,
  onChange: PropTypes.func,
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  DragHandle: PropTypes.func,
  onRemove: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired
}

export default TasklistItem
